import React from "react";
import styles from "../../../assets/stylesheets/blog/FarmmodeBlogDetail.module.css";
import MainImg from "../../../assets/img/blog/february/MainFebruary.webp"; 

import Elliott from "../../../assets/img/blog/february/Elliott.webp"; 
import Evergreen from "../../../assets/img/blog/february/Evergreen.webp"; // Using substitute as placeholder
import Kimber from "../../../assets/img/blog/february/Kimber.webp"; // Using substitute as placeholder
import Summit from "../../../assets/img/blog/february/Summit.webp"; // Using substitute as placeholder
import Triple from "../../../assets/img/blog/february/Triple.webp"; // Using substitute as placeholder

const FEBRUARY_FARMS = [
  {
    farms: [
      {
        name: "1. Elliott Tree Farm",
        img: Elliott,
        subTitle: "A quintessential Canadian winter experience.",
        description: "Elliott Tree Farm is a picturesque maple syrup farm in Hillsburgh, ON, offering a quintessential Canadian winter experience. This family-owned farm is renowned for its traditional maple syrup-making process and beautiful forest landscapes, making it one of the best farms to visit in February. Visitors can immerse themselves in the authentic process of syrup making while enjoying the farm’s cozy atmosphere.",
        location: "9467 Erin East Garafraxa Townline, Hillsburgh, ON",
        website: "Elliott Tree Farm",
        webUrl: "https://www.elliotttreefarm.ca/",
        details: [
          { label: "Activities", value: "Maple syrup tastings, sugar bush tours where you can learn the process of syrup making from tree tapping to bottling, and scenic winter walks through the snow-covered forest." },
          { label: "Admission", value: "Free entry; fees may apply for specific tours and tastings." },
          { label: "Open Hours", value: "Saturdays and Sundays, 10 AM – 4 PM." },
          { label: "Maple Syrup Experience", value: "The guided sugar bush tours take you through the maple tree groves, explaining the history and techniques of tree tapping and syrup production with a warm syrup tasting at the end." },
          { label: "Dates", value: "Opens Family Day weekend (February 15-17) and runs every weekend through April 6, including March Break (March 10 & 14) and PD Day (April 4)." },
          { label: "Schedule", value: "Four time slots available each day: 9:30 AM, 10:30 AM, 11:30 AM, and 12:30 PM. The sugar shack is open from 10 AM to 2 PM." },
          { label: "Activities (Experience)", value: "Start with an all-you-can-eat pancake breakfast with award-winning maple syrup, bacon, and sausage in the cozy Horse Barn Canteen. Then, take a 10-15 minute sugar bush trail walk to the sugar shack, where you can check sap buckets, watch the syrup-making process, and taste raw sap, partially cooked sap, maple sugar, and maple toffee over snow. Visit the Maple Syrup Museum of Ontario and shop for maple products and local gifts." },
          { label: "Admission (Experience)", value: "Adults (13+): $39.50 | Youth (6-12): $19.50 | Children 5 and under: Free (Prices subject to HST)" },
          { label: "Included", value: "Free parking, museum entry, pancake breakfast, farm and trail access, campfire, and complimentary toboggans for the trail." },
          { label: "Important Notes", value: "Online reservations only. | Dress for muddy spring conditions and bring appropriate footwear. | Dogs are welcome on leashes, including in the dining area. | Food may contain common allergens. | Tickets are non-refundable. Cash, debit, and credit are accepted." }
        ]
      },
      {
        name: "2. Summit Station Dairy",
        img: Summit,
        subTitle: "Experience farm life in Ontario and meet their famous cow, Valentina.",
        description: "Summit Station Dairy offers interactive dairy farm tours where visitors can experience farm life in Ontario and meet their famous cow, Valentina.",
        location: "241 Concession 5 E, Waterdown, ON",
        website: "Summit Station Dairy",
        webUrl: "https://summitstationdairy.com/",
        details: [
          { label: "Activities", value: "Weekly Saturday farm tours, meet and greet with their beloved cow mascot, Valentina, dairy tastings, and insights into sustainable farming practices." },
          { label: "Open Hours", value: "Saturdays, 10 AM – 2 PM." },
          { label: "Farm Tour Details", value: "The Saturday farm tours offer an immersive experience where visitors can watch milking demonstrations, learn about dairy processing, and even feed the cows. The highlight of the tour is meeting Valentina, the farm’s friendly cow, perfect for photo ops and gentle petting. The tour concludes with a tasting of fresh dairy products, including milk, cheese, and yogurt, all produced on-site." },
          { label: "Admission", value: "$10 per person; children under 5 are free." },
          { label: "Important Notes", value: "Tours fill up quickly, so advance booking is recommended. | Wear sturdy shoes for walking around the farm." }
        ]
      },
      {
        name: "3. Kimber Valley Farms",
        img: Kimber,
        subTitle: "A serene farm stay experience in a rustic cabin.",
        description: "Kimber Valley Farms offers a serene farm stay experience, allowing guests to unwind and enjoy the beauty of rural Ontario. The farm is surrounded by snow-covered landscapes, making it an ideal destination for a winter escape.",
        location: "264798 Southgate Rd 26, Southgate, ON",
        website: "Kimber Valley Farms",
        webUrl: "https://www.kimbervalleyfarms.ca/",
        details: [
          { label: "Activities", value: "Cozy farm stay experiences in rustic cabins, snowshoeing across open fields, relaxing by the fireplace, and interacting with farm animals, including sheep, goats and chickens." },
          { label: "Admission", value: "Prices vary depending on accommodation; check the website for booking details." },
          { label: "Open Hours", value: "Open daily, but stays must be booked in advance." },
          { label: "Kimber Valley Farms Cabin Rental", value: "Kimber Valley Farms offers cozy cabin rentals where guests can enjoy both comfortable accommodations and farm experiences. It’s the perfect spot to relax in nature and participate in various farm activities. While staying on the farm, guests can join guided tours to meet the animals, learn about farm operations, and experience the day-to-day life of a farmer. Visitors will have the chance to feed animals, collect fresh eggs, and learn about sustainable farming practices. During winter, guests can also participate in snowshoeing tours that explore the farm’s scenic trails, followed by hot cocoa by the fire." },
          { label: "Features", value: "Cozy cabins with modern amenities and scenic farm views" },
          { label: "Activities (Stay)", value: "Seasonal farm experiences, nature walks, campfires, and more" },
          { label: "Important Notes", value: "Perfect for a winter getaway—remember to pack warm clothes! | Booking ahead is essential during peak seasons." }
        ]
      },
      {
        name: "4. Triple C Farm",
        img: Triple,
        subTitle: "Alpaca and animal therapy farm with unique hands-on experiences.",
        description: "Triple C Farm is an alpaca and animal therapy farm that offers unique hands-on experiences with their friendly animals. It’s a perfect spot for animal lovers of all ages.",
        location: "500 Carluke Rd W, Ancaster, ON",
        website: "Triple C Farm",
        webUrl: "https://www.triplecfarm.ca/",
        details: [
          { label: "Activities", value: "Alpaca cuddling, goat interactions, animal therapy sessions, interactive farm tours, animal therapy experiences, and educational programs about animal care." },
          { label: "Admission", value: "Starting at $15 per person for general admission; special events may have different pricing." },
          { label: "Open Hours", value: "Saturdays and Sundays, 11 AM – 3 PM." },
          { label: "February Goat Yoga with Petting Farm", value: "Join Triple C Farm for a series of Goat Yoga sessions this February, followed by visits to the Petting Farm where you can interact with friendly farm animals. Perfect for a unique and relaxing experience!" },
          { label: "Dates", value: "February 9, 2025 | February 14, 2025 (Valentine’s Day Special) | February 15, 2025" },
          { label: "Highlights", value: "Fun yoga sessions with playful goats and post-yoga access to the petting farm" },
          { label: "Important Notes", value: "Pre-booking required for animal therapy sessions. | Wear clothes you don't mind getting a bit dirty, as you'll be up close with the animals!" }
        ]
      },
      {
        name: "5. Evergreen Brick Works Farmers Market",
        img: Evergreen,
        subTitle: "A vibrant community hub located in the Don Valley.",
        description: "Evergreen Brick Works is a vibrant community hub located in the Don Valley, offering a bustling farmers market every Saturday. It’s a great place to experience Toronto’s local food scene while enjoying the surrounding nature trails.",
        location: "550 Bayview Ave, Toronto, ON",
        website: "Evergreen Brick Works",
        webUrl: "https://www.evergreen.ca/evergreen-brick-works/",
        details: [
          { label: "Activities", value: "Explore local produce, artisanal foods, handmade crafts, and warm beverages at the farmers market. Enjoy scenic winter trails and educational workshops on sustainability." },
          { label: "Admission", value: "Free entry; costs depend on purchases at the market." },
          { label: "Open Hours", value: "Saturdays, 9 AM – 1 PM." },
          { label: "4 Ways to Enjoy Evergreen Brick Works This Week!", value: "Discover fun and unique ways to make the most of your visit to Evergreen Brick Works! From exploring scenic trails to enjoying local markets and workshops, there’s something for everyone to experience this week." },
          { label: "Important Notes", value: "Dress warmly, as part of the market is outdoors. | Public transportation or biking is encouraged due to limited parking. | Check their website for special winter events." }
        ]
      }
    ]
  }
];

export default function February() {
  return (
    <div className={styles.page}>

      {/* Top meta */}
      <div className={styles["top-meta"]}>
        {/* <span className={styles["category-name"]}>Best Farm</span>
        <span className={styles["sep"]}>•</span>
        <span>FarmCiti News</span>
        <span className={styles["sep"]}>•</span>
        <span>Posted Feb 7, 2025</span> */}
      </div>

      {/* Main Title */}
      <h1 className={styles["title"]}>The Best Farm to visit in February 2025</h1>

      {/* Hero Image */}
      <div className={styles["hero-wrap"]}>
        <img
          className={styles["hero"]}
          src={MainImg}
          alt="Best Farms February"
        />
      </div>

      <div className={styles["lead-section"]}>
        <p><strong>February might be chilly, but it’s the perfect time to explore some of Ontario’s best farms to visit in winter.</strong><br />
        From maple syrup farms to cozy farm stays, these destinations offer exciting winter farm experiences for all ages. Whether you’re planning a family-friendly farm visit or a weekend getaway, these farms have something special to offer.</p>
        <p>Here’s a list of the best farms to visit this February, complete with activities, admission details, and key highlights.</p>
      </div>

      <div className={styles["jump-links"]}>
        {/* Simple jump link placeholder if needed */}
      </div>

      {FEBRUARY_FARMS.map((region, idx) => (
        <div key={idx}>
          {region.region && (
            <>
            <h2 className={styles["region-title"]}>{region.region}</h2>
            <hr className={styles["region-divider"]} />
            </>
          )}
          
          {region.farms.map((farm, fIdx) => (
            <div key={fIdx} className={styles["farm-section"]}>
              <h3 className={styles["farm-name"]}>{farm.name}</h3>
              <hr className={styles["region-divider"]} />
              
              {farm.img && <img src={farm.img} alt={farm.name} className={styles["farm-image"]} />}
              
              <div className={styles["farm-description"]}>
                <p><strong>{farm.subTitle}</strong></p>
                <p>{farm.description}</p>
              </div>

              <div className={styles["event-details-title"]}>Event Details:</div>
              <ul className={styles["details-list"]}>
                <li className={styles["details-item"]}>
                  <span className={styles["details-label"]}>Location:</span> {farm.location}
                </li>
                <li className={styles["details-item"]}>
                  <span className={styles["details-label"]}>Website:</span><br />
                  <a href={farm.webUrl} className={styles["website-link"]} target="_blank" rel="noopener noreferrer">
                    {farm.website}
                  </a>
                </li>
                {farm.details && farm.details.map((detail, dIdx) => {
                  const isHighlight = ["Important Notes", "Highlights", "Example Highlight"].includes(detail.label);
                  if (isHighlight) {
                    let contentItems = [];
                    if (detail.value.includes('|')) {
                      contentItems = detail.value.split('|').map(s => s.trim());
                    } else {
                      contentItems = [detail.value];
                    }

                    return (
                      <li key={dIdx} className={styles["highlight-detail"]}>
                        <span className={styles["highlight-label"]}>{detail.label}</span>
                        <div className={styles["highlight-content"]}>
                          <ul className={styles["highlight-list"]}>
                            {contentItems.map((item, i) => (
                              <li key={i}>{item}</li>
                            ))}
                          </ul>
                        </div>
                      </li>
                    );
                  }
                  return (
                    <li key={dIdx} className={styles["details-item"]}>
                      <span className={styles["details-label"]}>{detail.label}:</span> {detail.value}
                    </li>
                  );
                })}
              </ul>
              <hr className={styles["farm-divider"]} />
            </div>
          ))}
        </div>
      ))}

      <div className={styles["lead-section"]}>
        <h2 className={styles["title"]} style={{ fontSize: '2rem', marginTop: '3rem' }}>Planning Your Winter Farm Visit?</h2>
        <p>Check each farm’s official website for hours and ticket reservations. Many events sell out fast — especially authentic maple syrup experiences and farm stays!</p>
      </div>
    </div>
  );
}
